/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * }); 
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

//$('.checkout-button').prop("disabled", true);

if(window.location.href == `https://${window.themeVariables.routes.host}${window.themeVariables.routes.cartUrl}`){
  $.getJSON("/cart.js", function(data, status){
    CheckQuantity(data);    
  });
}	

document.addEventListener('cart:updated', function(event) {
  $("#quantity-content").empty();
  var cart = event.detail.cart; // Get the updated content of the cart
  CheckQuantity(cart);
});



function QuantityMaps(){
  const quantityMin = new Map([]);
  const quantityMax = new Map([]);

  const extractBrackets = /(?<=\[).+?(?=\])/g;  //This matches all items inside square brackets 
  const extractKey = /.*(?=(\:))/g;				//Selects all characters or Digits before :

  let windowData = window.themeVariables.settings.quantityChecker; //Gets our productDiscount string
  
  
  for(let i = 0; i < windowData.length; i++){

    let initialKey = windowData[i].match(extractKey).toString(); //takes out the key
    
    let values = windowData[i].match(extractBrackets).toString(); 
    let newValues = values.split(",");
    let quantityMinVals = [];
    let quantityMaxVals = [];
    let replacedKey = initialKey.replace(",", "");
    let key = replacedKey.toLowerCase();
    

    for(let i = 0; i < newValues.length; i++){
      if((i % 2) == 0){
        quantityMinVals.push(newValues[i]);
      }
      else{
        quantityMaxVals.push(newValues[i]);
      }
    } 
    quantityMin.set(key, quantityMinVals);
    quantityMax.set(key, quantityMaxVals);
  }
  
  return {quantityMin, quantityMax};  

}

function CheckQuantity(cart){
  
  let ourMaps = QuantityMaps();
	
  let quantityMin = ourMaps.quantityMin;
  let quantityMax = ourMaps.quantityMax;

  let invalidCart = false;
  let invalidItems = [];
  for(let n = 0; n < cart.items.length; n++){

    if(quantityMin.has((cart.items[n].product_type).toLowerCase()) && cart.items[n].product_id != 7274512842908){ //This must be changed to an ajax request dealing with the actual product tag. This is the styling guide
      let minQuantity = quantityMin.get((cart.items[n].product_type).toLowerCase());
      let maxQuantity = quantityMax.get((cart.items[n].product_type).toLowerCase());
      let optionValue = cart.items[n].options_with_values[0].value != undefined && cart.items[n].options_with_values[0].value != "Default Title" ? cart.items[n].options_with_values[0].value : "";
      let colorVal = cart.items[n].properties.Color != undefined ? cart.items[n].properties.Color : "";
      if(minQuantity > cart.items[n].quantity){
        invalidCart = true;
        invalidItems.push(`<li>${cart.items[n].product_title} - Minimum Quantity ${minQuantity}.</li>`);
      // $('.checkout-button').prop("disabled", true);
        //$('.checkout-button').find(".loader-button__text").text("Invalid Quantity");

		//${cart.items[n].variant_title} if nul
      }else if(maxQuantity < cart.items[n].quantity){
      	invalidCart = true;      
        invalidItems.push(`<li>${cart.items[n].product_title} - limit ${maxQuantity} per customer.</li>`);
      
		//$('.checkout-button').prop("disabled", true);
		//$('.checkout-button').find(".loader-button__text").text("Invalid Quantity");

      }

      
    }
  }
  if(invalidCart == true && (window.location.href == `https://${window.themeVariables.routes.host}${window.themeVariables.routes.cartUrl}`)){
   // invalidItems.forEach((e)=>{
    //  $("#quantity-content").append(e);
   // });
   
  	$("#quantity-modal").prop("open", true);
    
  }else if(invalidCart == true){
    invalidItems.forEach((e)=>{
    	$("#quantity-content").append(e);
    });
   
  	$('.checkout-button').prop("disabled", false);
	$("#quantity-modal").prop("open", false);
    
  }else{
  
  	$('.checkout-button').prop("disabled", false);
	$("#quantity-modal").prop("open", false);
  }
}

window.addEventListener('popstate', function (event) {
	// Log the state data to the console
    try{
      const url = new URL( window.location.href);
      const urlHash = url.hash;
      if(urlHash == "#front_open"){
        window.FrontChat("show");
      }
    }catch(e){
      console.log(e);
    }
});
  let chatElements = document.getElementsByClassName("front_open");
  for(let i = 0; i < chatElements.length;i++){
    chatElements[i].addEventListener("click", (e)=>{
      window.FrontChat("show");
    })
  }

// Add a text field on var change if matching Metaobject sku
document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let insert = false;

  let insertedElements = document.getElementsByClassName("variable-block-form");
  let inputElements = document.getElementsByClassName("variable-block-input");
  let skuShowList = window.themeVariables.settings.sku_display_list;

  for(let i = 0; i < inputElements.length; i++){
    let parentElem = inputElements[i].parentElement.parentElement;
    let elemSkus = parentElem.getAttribute("sku_display").split("\n");
    let matchingSku = false;
    for(let j = 0; j < elemSkus.length; j++){
      if(variant.sku.includes(elemSkus[j])){
        matchingSku = true;
      }
    }
    if(elemSkus == null || matchingSku){
      if(parentElem.classList.contains("hidden")){
        inputElements[i].setAttribute("form", window.themeVariables.settings.product_form_id);
      }
    }else{
      inputElements[i].setAttribute("form", "");
    }
  }
  for(let i = 0; i < insertedElements.length; i++){
    let testSkus = insertedElements[i].getAttribute("sku_display").split("\n");
    let matchingSku = false;
    for(let j = 0; j < testSkus.length; j++){
      if(variant.sku.includes(testSkus[j])){
        matchingSku = true;
      }
    }
    if(matchingSku){
      if(insertedElements[i].classList.contains("hidden")){
        insertedElements[i].classList.remove("hidden");
        insertedElements[i].classList.add("visible");
      }
    }else{
      insertedElements[i].classList.add("hidden");
      insertedElements[i].classList.remove("visible");
    }
  }
});

//This block adjusts the zIndex of the viewing area for the zoom.
//Reason for this is StarApps duplicated img viewer falls behind all domcontent
//This listens to the og get changed to hidden, then finds the new element and their respective triggers
function initiateObserver(){
  try {
    let observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutationRecord) {
        let buttonElems = document.getElementsByClassName("tap-area product__zoom-button");
        addListenerToZoomButton(buttonElems[1]);
      });    
    });
    let target = document.getElementById("product_media_ob");
    observer.observe(target, { attributes : true, attributeFilter : ['style'] });
  } catch (error) {
    
  }

}

initiateObserver();
function addListenerToZoomButton(elem){
    try {
      elem.addEventListener("click", ()=>{
        let variantZoomElement = document.getElementsByClassName("product__media starapps")[0];
        adjustVariantZoomElem(variantZoomElement, 5)
        let modalCloseButton = document.getElementsByClassName("pswp__button pswp__button--close prev-next-button")[0];
        modalCloseButton.addEventListener("click", ()=>{ adjustVariantZoomElem(variantZoomElement, 3)})
        
      });
    } catch (error) {
      console.log("Error:", error)
    }

}
function adjustVariantZoomElem(elem, amount){
  elem.style.zIndex = amount;
}
document.addEventListener('variant:changed', function(event) {
  setTimeout(()=>{ //Sets a delay for the redrawing of the image section
      let buttonElems = document.getElementsByClassName("tap-area product__zoom-button");
      addListenerToZoomButton(buttonElems[1]);
  },500)
});
//set on variant change

/*
  Start of control for Personalize this button 

document.getElementById("personalize_button").addEventListener("click", (event)=>{
  if(window.location.href.includes("cart")){
    populatePersonalizeEdit(event.currentTarget);
  }
  togglePersonalizeModalStatus();
});*/
setupPersonalizeButtons();
function setupPersonalizeButtons(){
  try{
    let buttons = document.querySelectorAll("#personalize_button");
    for(let i =0; i < buttons.length;i++){
     buttons[i].addEventListener("click", (event)=>{
        if(window.location.href.includes("cart")){
          populatePersonalizeEdit(event.currentTarget);
        }
        togglePersonalizeModalStatus();
      })
    }
  }catch(e){
    
  }

  try {
    document.getElementById("closePersonalizeModal").addEventListener("click",(event)=>{
      togglePersonalizeModalStatus();
    })
  } catch (error) {
    
  }
  try{
    document.getElementById("personalize-AddToCart").addEventListener("click",(event)=>{
      event.currentTarget.setAttribute("disabled", "disabled");
      event.currentTarget.setAttribute("aria-busy", "true");
      document.getElementById("AddToCart").click();
      setTimeout(()=>{
        togglePersonalizeModalStatus();
        resetProxyCartButtonStatus();
      }, 1000)
    })   
  }catch(e){
    
  }
  try{
    document.getElementById("personalizeModalBackground").addEventListener("click", (event)=>{
      if(event.target == document.getElementById("personalizeModalBackground")){
        event.currentTarget.classList.add("hidden");
        resetProxyCartButtonStatus()
      }
    })
  }catch(e){
    
  }

  try {
    document.getElementById("personalize-update").addEventListener("click", (event)=>{
      submitPersonalizedChanges(event.currentTarget.getAttribute("key"));
    })    
  } catch (error) {
    
  }

}


document.addEventListener('cart:updated', function(event) {
  var cart = event.detail.cart; // Get the updated content of the cart
  resetProxyCartButtonStatus();
});

function resetProxyCartButtonStatus(){
  console.log("reset")
  let elem = document.getElementById("personalize-AddToCart")
  elem.removeAttribute("disabled");
  elem.setAttribute("aria-busy", "false");
}

function togglePersonalizeModalStatus(){
  let elem = document.getElementById("personalizeModalBackground");
  elem.classList.toggle("hidden");
}
function populatePersonalizeEdit(target){
  let targetKey = target.getAttribute("key");
  let cart = window.cartInfo;
  for(let i = 0; i < cart.items.length; i++){
    if(cart.items[i].key === targetKey){
      document.getElementById("wording_text").innerText = cart.items[i].properties.Wording;
      document.getElementById("alterations_text").innerText = cart.items[i].properties.Alterations;
      document.getElementById("personalize-update").setAttribute("key", targetKey);
    }
  }
}
function submitPersonalizedChanges(key){
  let item;
  let cart = window.cartInfo;

  for(let i = 0; i < cart.items.length; i++){
    if(cart.items[i].key === key){
      item = cart.items[i];
    }
  }
  let wordingText = document.getElementById("wording_text").value;
  let alterationsText = document.getElementById("alterations_text").value;
  let properties = item.properties;
  properties.Wording = wordingText;
  properties.Alterations = alterationsText;
  
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      id: key,
      quantity: item.quantity,
      properties
    },
    success: function (data){
       //refresh the page
      console.log("changed", data);
      window.location.reload()
    },error: function(xhr, status, error) {
      console.log("error");
      console.log(xhr);
    }
  }); 
  
}